import { Box } from '@mui/material';

import RoomInfo from './RoomInfo';

import { sxStyle } from './styles';

const Rooms = ({ rooms }) => {
  return (
    <Box sx={sxStyle.roomsBox}>
      <Box sx={sxStyle.roomsFlexBox}>
        <Box style={{ width: '100%' }}>
          {rooms?.map((room, index) => (
            <RoomInfo key={index} room={room} index={index} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Rooms;
